<template>
  <div class="top-nav" :style="{ width: sidebar.opened ? 'calc(100vw - 200px)' : 'calc(100vw - 54px)' }">
    <fav-top-menu v-if="favTopShow"></fav-top-menu>
    <tags-view />
  </div>
</template>

<script>
import { mapGetters, mapState, mapMutations } from "vuex"
import variables from "@/styles/variables.scss"
const defaultImg = "https://tfmall-test.oss-cn-shenzhen.aliyuncs.com/storage/images/image/tanfeizanweitu/8220359a06bb5a34a114a54d74a9b9e3.png"
import { apiCommentNotifyRead } from "@/api/wx-chat/comment"
import { apiCommentNotifyReadNew } from "@/api/voyager/moments"
import dayjs from "dayjs"
import { TagsView } from "@/layout/components"
import FavTopMenu from "@/layout/components/FavTopMenu/index.vue"

export default {
  name: "TopNav",
  components: {
    TagsView,
    FavTopMenu
  },
  data() {
    return {
      activeIndex: "1",
      activeIndex2: "1",
      imgSrc: defaultImg,
      scrollLeft: 0,
      isMiniWindow: false,
      showRight: true,
      showLeft: false,
      visible: false
    }
  },
  computed: {
    ...mapGetters(["avatar", "sidebar"]),
    ...mapState("app", ["nowRouteInfo"]),
    ...mapState("user", ["userInfo"]),
    ...mapState("comment", ["commentNotifyList"]),
    ...mapState("tagsView", ["favTopShow"]),
    activeMenu() {
      const route = this.$route
      const { fullPath } = route
      return fullPath
    },
    variables() {
      return variables
    },
    showTools() {
      // return ["太阳", "绅一", "墨君", "马修诺", "玉小刚", "皮可西", "达佐"].indexOf(this.userInfo.userName) > -1
      return true
    }
  },
  watch: {
    nowRouteInfo() {
      this.isMiniWindow = false
      this.$nextTick(() => {
        this.checkNavWidth()
      })
    },
    "sidebar.opened": {
      handler() {
        this.isMiniWindow = false
        this.$nextTick(() => {
          this.checkNavWidth()
        })
      }
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.checkNavWidth()
    })
  },
  methods: {
    ...mapMutations("comment", ["GET_COMMENT_NOTIFY_LIST", "RESET_PAGE"]),
    // 判断当前屏幕是否可以显示下菜单
    checkNavWidth() {
      const canSeeWidth = this.sidebar.opened ? document.body.clientWidth - 400 : document.body.clientWidth - 300
      let navNum = 0
      if (document.querySelector("#top-nav_menubox-nav")) {
        document.querySelector("#top-nav_menubox-nav").childNodes.forEach(item => {
          if (item.innerText) {
            navNum++
          }
        })
      }
      if (navNum * 125 > canSeeWidth) {
        this.isMiniWindow = true
      } else {
        this.isMiniWindow = false
      }
    },
    // 点击小屏幕下左右按钮
    goScroll(type) {
      let scrollLeft = this.scrollLeft
      const realNavWidth = document.querySelector("#top-nav_menubox-nav").clientWidth
      if (type === "left") {
        scrollLeft = scrollLeft - realNavWidth / 2
        if (scrollLeft <= 0) {
          scrollLeft = 0
          this.showLeft = false
        }
        this.showRight = true
      } else {
        scrollLeft = scrollLeft + realNavWidth / 2
        if (scrollLeft >= realNavWidth) {
          scrollLeft = realNavWidth
          this.showRight = false
        }
        this.showLeft = true
      }
      this.scrollLeft = scrollLeft
      document.getElementById("top-nav_menubox-nav").scrollLeft = scrollLeft
    },
    toggleSideBar() {
      this.$store.dispatch("app/toggleSideBar")
    },
    handleSelect(key, keyPath) {
      console.log(key, keyPath)
    },
    commentNotifyRead(item) {
      this.visible = false
      if (item.chatAccountId) {
        const chatAccountIdList = this.commentNotifyList.map(item => item.chatAccountId).filter(chatAccountId => chatAccountId !== undefined)
        apiCommentNotifyReadNew({
          chatAccountIds: [...new Set(chatAccountIdList)]
        }).then(res => {
          this.RESET_PAGE(true)
          this.GET_COMMENT_NOTIFY_LIST([])
          this.$router.push({ path: "/voyager#/voyager/wechatMoments/commentMoments" })
        })
      } else {
        const wxUins = this.commentNotifyList.map(item => item.wxUin).filter(wxUin => wxUin !== undefined)
        apiCommentNotifyRead({
          uinList: [...new Set(wxUins)]
        }).then(res => {
          this.RESET_PAGE(true)
          this.GET_COMMENT_NOTIFY_LIST([])
          this.$router.push({ path: "/userData#/userData/wechatMoments/commentMoments" })
        })
      }
    },
    async openMemoryTools() {
      // 网易sdk,js缓存溢出删除indexDB数据库
      const dbs = await indexedDB.databases()
      let deletDbName = ""
      dbs.forEach(item => {
        if (item.name.indexOf("nim-log-") > -1) {
          deletDbName = item.name
        }
      })
      const request = window.indexedDB.open(deletDbName, 1)

      request.onsuccess = event => {
        const db = event.target.result
        // 关闭数据库连接
        db.close()

        // 删除数据库
        const deleteRequest = window.indexedDB.deleteDatabase(deletDbName)
        this.$message.success("当前页面数据库清理完成")
        deleteRequest.onsuccess = function () {
          console.log(deletDbName + ":数据库删除成功")
        }

        deleteRequest.onerror = function (event) {
          console.error(deletDbName + ":数据库删除失败:", event.target.error)
        }
      }

      request.onerror = function (event) {
        console.error("打开数据库失败:", event.target.error)
      }
      // 检测用户的设备是否是Windows系统
      // 物理缓存删除
      if (/windows|win32/i.test(navigator.userAgent)) {
        // 检测用户的浏览器是否能使用universalLink
        let openApp = false
        const userAgent = navigator.userAgent
        // 判断是否 Firefox浏览器
        if (userAgent.indexOf("Firefox") > -1) {
          openApp = true
        }
        // 判断是否 Chrome浏览器
        if (userAgent.indexOf("Chrome") > -1) {
          openApp = true
        }
        // 判断是否 Edge浏览器
        if (userAgent.indexOf("Edg") > -1) {
          openApp = true
        }
        if (openApp) {
          try {
            window.location.href = "universalLink://"
          } catch (err) {
            this.$message.warning("请先安装该软件")
            console.log(err)
          }
        } else {
          this.$message.warning("您的浏览器不支持自动打开该工具，请前往D盘打开memreduct.exe！")
          this.$notify.warning({
            title: "提示",
            content: "推荐使用Chrome浏览器！",
            placement: "bottom-right",
            duration: 3000
          })
        }
      } else {
        this.$message.warning("您的设备暂不支持运行小程序，请在Windows电脑上进行操作！")
      }
    },
    formatTime(val) {
      return dayjs(val).format("YYYY-MM-DD HH:mm:ss")
    }
  }
}
</script>

<style scoped lang="scss">
.top-nav_logo {
  width: 118px;
  float: left;
  margin-left: 17px;
  margin-top: 8px;
}
.top-nav_logosmall {
  width: 28px;
  float: left;
  margin-left: 14px;
  margin-top: 8px;
}
.hamburger-container {
  line-height: 40px;
  height: 100%;
  float: left;
  cursor: pointer;
  transition: background 0.3s;
  -webkit-tap-highlight-color: transparent;
  &:hover {
    background: rgba(0, 0, 0, 0.025);
  }
}
.ml8 {
  margin-left: 8px !important;
}
.right-menu {
  float: right;
  height: 100%;
  line-height: 50px;

  &:focus {
    outline: none;
  }

  .msg {
    color: #999;
    height: 100%;
    position: absolute;
    left: -40px;
    cursor: pointer;
    .badge {
      position: absolute;
      right: -18px;
      top: -8px;
    }

    .icon-xiaoxi {
      line-height: 45px;
    }
  }

  .right-menu-item {
    display: inline-block;
    padding: 0 8px;
    height: 100%;
    font-size: 18px;
    color: #5a5e66;
    vertical-align: text-bottom;

    &.hover-effect {
      cursor: pointer;
      transition: background 0.3s;

      &:hover {
        background: rgba(0, 0, 0, 0.025);
      }
    }
  }

  .avatar-container {
    margin-right: 30px;
    height: 100%;
    cursor: pointer;
    .avatar-wrapper {
      position: relative;
      display: flex;
      align-items: center;
      height: 100%;
      .user-avatar {
        cursor: pointer;
        width: 24px;
        height: 24px;
        border-radius: 50%;
      }
      span {
        color: #999;
        margin-left: 8px;
      }

      .el-icon-caret-bottom {
        cursor: pointer;
        position: absolute;
        right: -20px;
        font-size: 12px;
        color: #999;
      }
    }
  }
}
.mini-window {
  width: calc(100vw - 370px);
  padding: 0 10px;
}
.mini-window_scroll {
  width: calc(100vw - 370px);
  overflow-x: scroll;
  overflow-y: hidden;
  scroll-behavior: smooth;
}
.top-nav_menubox {
  display: flex;
  position: relative;
  .leftbtn {
    position: absolute;
    left: -30px;
    top: 2px;
    cursor: pointer;
    z-index: 9;
    padding: 10px;
    img {
      width: 18px;
    }
  }
  .rightbtn {
    position: absolute;
    right: -30px;
    top: 2px;
    cursor: pointer;
    z-index: 9;
    padding: 10px;
    img {
      width: 18px;
    }
  }
}
</style>
<!--需要改el公共样式-->
<style lang="scss">
.top-nav {
  .el-menu {
    background: none;
  }
  .el-menu-top {
    float: left;
    background: none;
    .el-menu-top_box {
      display: flex;
    }
  }
  .el-menu-item,
  .el-submenu__title {
    height: 45px;
    line-height: 45px;
    display: flex;
    align-items: center;
    svg {
      width: 15px;
      height: 15px;
      margin: 0 10px 0px 0px;
    }
  }
  .el-menu--horizontal > .el-menu-item.is-active {
    border-bottom: 0px;
    color: #fff;
    background: $menuHover;
  }
  .el-menu-item:focus,
  .el-menu-item:hover {
    background: $menuHover;
    border-bottom: 0px;
    color: #fff;
  }
  .el-submenu__icon-arrow {
    right: 18px;
    color: #ffffff;
    margin-top: -6px;
    margin-left: -2px;
  }
  // menu hover
  .submenu-title-noDropdown,
  .el-submenu__title {
    &:hover {
      background-color: $menuHover !important;
    }
    &:focus {
      background-color: $menuHover !important;
    }
  }

  .is-active > .el-submenu__title {
    color: $subMenuActiveText !important;
    background-color: $menuHover;
  }
  .el-menu-item.is-active {
    color: $subMenuActiveText !important;
    background-color: $menuHover;
  }
  & .nest-menu .el-submenu > .el-submenu__title,
  & .el-submenu .el-menu-item {
    min-width: $sideBarWidth !important;
    background-color: $subMenuBg !important;

    &:hover {
      background-color: $subMenuHover !important;
    }
  }
  .el-menu--horizontal > .el-submenu .el-submenu__title {
    height: 45px;
    line-height: 45px;
    border-bottom: 2px solid transparent;
    color: #ffffff;
    &:hover {
      background-color: $menuHover;
    }
  }

  .el-badge__content {
    border: none !important;
  }
}
.user-dropdown {
  //top: 30px !important;
}
.memory-tools {
  width: 20px;
  height: 30px;
  cursor: pointer;
  position: absolute;
  left: -80px;
  top: 4px;
  svg {
    width: 100%;
  }
}
</style>
